import AddIcon from '@/components/Icons/Add';
import clsx from 'clsx';

interface CustomPromptProps {
  disabled: boolean;
  onClick: () => void;
}

export default function CustomPrompt({ disabled, onClick }: CustomPromptProps) {
  return (
    <>
      <p className="text-h2 mb-24 text-neutral-500">Play Your Way</p>
      <div className={`flex flex-col gap-8`}>
        <div
          className={clsx(
            'p-12 rounded-xs min-h-100 flex items-center justify-center w-full shrink-0 text-center',
            !disabled && 'hover:border-primary-500 hover:cursor-pointer',
            disabled
              ? 'bg-neutral-100 border-1 border-neutral-200  hover:cursor-not-allowed'
              : 'bg-white border-1 border-neutral-500'
          )}
          onClick={!disabled ? onClick : undefined}
        >
          <div className="flex items-center justify-center gap-8">
            <AddIcon />
            <h2
              className={clsx(
                'text-body-strong',
                disabled ? 'text-neutral-400' : 'text-neutral-500'
              )}
            >
              Create Custom Prompt
            </h2>
          </div>
        </div>
        <p className="text-body-sm text-center text-neutral-400">
          You can add one or more custom prompts to this game. Custom prompts are only available for
          this session and won’t be saved for future use.
        </p>
      </div>
    </>
  );
}
